(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Selectors for both header and announcement bar
    this.header = document.querySelector('.section-header');
    const customAnnouncementBar = document.querySelector('[data-announcement-bar-custom]');
    this.announcementBar =
      customAnnouncementBar?.closest('.announcement-bar-custom-section') ||
      document.querySelector('.announcement-bar-section');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    this.announcementResizeObserver = this.announcementBar
      ? new ResizeObserver(this.setHeaderHeight.bind(this))
      : null;
    this.announcementResizeObserver?.observe(this.announcementBar);

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header?.classList.add('shopify-section-header-sticky');
      this.announcementBar?.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

    setHeaderHeight() {
      const announcementHeight = this.announcementBar?.offsetHeight || 0;
      const totalHeight =
        (this.header?.offsetHeight || 0) +
        announcementHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
      document.documentElement.style.setProperty('--header-height', `${totalHeight}px`);
    }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    this.announcementResizeObserver?.disconnect();
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    if (this.header) observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.toggleSticky(true);
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.toggleSticky(true);
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.toggleSticky(false);
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  toggleSticky(enable) {
    if (enable) {
      this.header?.classList.add('scrolled-past-header');
      this.announcementBar?.classList.add('scrolled-past-header');
    } else {
      this.header?.classList.remove('scrolled-past-header');
      this.announcementBar?.classList.remove('scrolled-past-header');
    }
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header?.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.announcementBar?.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header?.classList.add('shopify-section-header-sticky', 'animate');
    this.header?.classList.remove('shopify-section-header-hidden');
    this.announcementBar?.classList.add('shopify-section-header-sticky', 'animate');
    this.announcementBar?.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header?.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    this.announcementBar?.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header?.querySelectorAll('header-menu');
    this.disclosures?.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header?.querySelector('details-modal');
    this.searchModal?.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocean-catalog-hero"] && !Shopify.designMode) return;
  try {
    
	(function () {
		var navs = document.querySelectorAll('[data-catalog-tabs]');
		if (!navs.length) return;

		function headerOffset() {
			var header = document.querySelector('sticky-header, .header-wrapper, #shopify-section-header');
			return header ? header.getBoundingClientRect().height + 8 : 80;
		}

		function getSection(target) {
			if (target) return document.getElementById('catalog-' + target);
			return document.querySelector('[id^="catalog-"]');
		}

		function setActive(nav, tab) {
			if (!tab) return;
			nav.querySelectorAll('[data-catalog-tab]').forEach(function (el) {
				if (el === tab) {
					el.setAttribute('aria-current', 'page');
					el.setAttribute('aria-selected', 'true');
				} else {
					el.removeAttribute('aria-current');
					el.removeAttribute('aria-selected');
				}
			});
		}

		function scrollToSection(section) {
			var top = section.getBoundingClientRect().top + window.scrollY - headerOffset();
			window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
		}

		navs.forEach(function (nav) {
			nav.querySelectorAll('[data-catalog-tab]').forEach(function (tab) {
				tab.addEventListener('click', function (event) {
					var target = tab.getAttribute('data-target') || '';
					var section = getSection(target);
					if (!section) return;
					event.preventDefault();
					setActive(nav, tab);
					scrollToSection(section);
					if (target) {
						history.replaceState(null, '', '#catalog-' + target);
					} else {
						history.replaceState(null, '', window.location.pathname + window.location.search);
					}
				});
			});
		});

		var hash = window.location.hash.replace('#catalog-', '');
		if (hash) {
			navs.forEach(function (nav) {
				var match = nav.querySelector('[data-catalog-tab][data-target="' + hash + '"]');
				if (match) setActive(nav, match);
			});
			var hashedSection = getSection(hash);
			if (hashedSection) {
				window.requestAnimationFrame(function () {
					scrollToSection(hashedSection);
				});
			}
		}

		if (!('IntersectionObserver' in window)) return;

		var ratios = {};
		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					ratios[entry.target.id] = entry.isIntersecting ? entry.intersectionRatio : 0;
				});

				var bestId = '';
				var best = 0;
				Object.keys(ratios).forEach(function (id) {
					if (ratios[id] > best) {
						best = ratios[id];
						bestId = id;
					}
				});

				navs.forEach(function (nav) {
					var target = bestId.replace('catalog-', '');
					var match = best > 0.15 ? nav.querySelector('[data-catalog-tab][data-target="' + target + '"]') : null;
					var fallback = nav.querySelector('[data-catalog-tab][data-target=""]');
					setActive(nav, match || fallback);
				});
			},
			{
				rootMargin: '-20% 0px -45% 0px',
				threshold: [0, 0.15, 0.3, 0.5, 0.75],
			}
		);

		document.querySelectorAll('[id^="catalog-"]').forEach(function (section) {
			observer.observe(section);
		});
	})();

  } catch(e) { console.error(e); }
})();
})();
